import { Stack, Text } from 'office-ui-fabric-react';

import React = require('react');
import { stackStyles } from './renderers';

export let status_thank_you_renderer = (input: string) => {
    return (
    <Stack styles={stackStyles}>
        <Stack className="styled-text">
            <p
                dangerouslySetInnerHTML={{ __html: input }}
            />
        </Stack>
    </Stack>
    )
}

export let status_sending_renderer = () => {
    return (
    <Stack styles={stackStyles}>
        <Stack>
            <Text variant={'mediumPlus'} className="message"> Versturen... </Text>
        </Stack>
    </Stack>
    )
}

export let status_error_renderer = () => {
    return (
    <Stack styles={stackStyles}>
        <Stack>
            <Text variant={'mediumPlus'} className="message message--error"> Er is iets misgegaan, probeer het later nog eens... </Text>
        </Stack>
    </Stack>
    )
}